// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__391Uv","list":"PatternAutocomplete_list__1Tf_t"};